function flash(arg) {
  flashApp.pushFlashes(arg);
}

['error', 'alert', 'notice', 'success'].forEach(flashType => {
  flash[flashType] = (message) => flashApp.pushFlashes({ [flashType]: message })
});

export default flash;